module.exports = __webpack_public_path__ + "static/media/img-mobileapp.8bd8cade.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img-mobileapp.png
// module id = 1077
// module chunks = 0